import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import api from "../../lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import Seo from "../../components/Seo";

const STATUSES = ["Requested", "Confirmed", "Rescheduled", "Completed", "Cancelled"];
const color = { Requested: "bg-blue-100 text-blue-800", Confirmed: "bg-indigo-100 text-indigo-800", Rescheduled: "bg-amber-100 text-amber-800", Completed: "bg-indigo-100 text-indigo-800", Cancelled: "bg-slate-200 text-slate-600" };

export default function AdminSiteVisits() {
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ["site-visits"], queryFn: async () => (await api.get("/admin/site-visits")).data });
  const update = async (id, body) => { try { await api.patch(`/admin/site-visits/${id}`, body); qc.invalidateQueries({ queryKey: ["site-visits"] }); toast.success("Updated"); } catch { toast.error("Failed"); } };

  return (
    <div>
      <Seo title="Site Visits | Admin" />
      <h1 className="font-heading text-2xl sm:text-3xl font-extrabold text-slate-900">Site Visits</h1>
      <p className="text-slate-500">Approve, reschedule or complete requested visits.</p>
      <div className="bg-white rounded-2xl border border-slate-200 mt-5 overflow-x-auto">
        <table className="w-full text-sm" data-testid="visits-table">
          <thead><tr className="border-b border-slate-100 text-left text-slate-500"><th className="p-4">Customer</th><th className="p-4">Property</th><th className="p-4">Preferred</th><th className="p-4">Status</th></tr></thead>
          <tbody>
            {(data?.items || []).map((v) => (
              <tr key={v.id} className="border-b border-slate-50 hover:bg-slate-50/50">
                <td className="p-4"><div className="font-medium text-slate-900">{v.name}</div><div className="text-xs text-slate-400">{v.mobile}</div></td>
                <td className="p-4 text-slate-600 text-xs">{v.property_title || "—"}</td>
                <td className="p-4 text-slate-600">{v.preferred_date} · {v.preferred_time}</td>
                <td className="p-4">
                  <Select value={v.status} onValueChange={(s) => update(v.id, { status: s })}>
                    <SelectTrigger className={`h-8 text-xs w-[150px] ${color[v.status] || ""}`} data-testid={`visit-status-${v.id}`}><SelectValue /></SelectTrigger>
                    <SelectContent>{STATUSES.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent>
                  </Select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {!data?.items?.length && <div className="p-12 text-center text-slate-400">No site visit requests yet.</div>}
      </div>
    </div>
  );
}
